module.exports = function(bootstrap) {

    'use strict';
    bootstrap.directive('buttonBuilder', [function() {

        return {
            restrict: 'A',
            replace: false,

            template:'<button data-ng-if="toggle" aria-label="{{name ? name : modalText}}" data-skip-open="true"  data-tooltip="modalText" class="buttonbuilder tooltipAction"><span  data-skip-open="true" ><span  data-skip-open="true" class="{{iconClasses}}"></span><span  data-skip-open="true" class="align-icons">{{name}}</span></span></button> ',
            scope: {
                toggle: '=',
                iconClasses: '=',
                modalText:'=',
                name:'=',


            }
        };
    }]);
};
